"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YesNoConfirmation = void 0;
const react_1 = __importDefault(require("react"));
const design_system_1 = require("@servicetitan/design-system");
const classnames_1 = __importDefault(require("classnames"));
const Styles = __importStar(require("./yes-no-confirmation.module.css"));
// TODO: think about suitable default title
exports.YesNoConfirmation = ({ title = '', message = '', onConfirm, onDecline, onCancel, }) => (react_1.default.createElement(design_system_1.Modal, { open: true, closable: true, onClose: onCancel, size: design_system_1.Modal.Sizes.S, title: title, footer: react_1.default.createElement(design_system_1.ButtonGroup, null,
        react_1.default.createElement(design_system_1.Button, { onClick: onCancel }, "Cancel"),
        react_1.default.createElement(design_system_1.Button, { negative: true, onClick: onDecline }, "No"),
        react_1.default.createElement(design_system_1.Button, { primary: true, onClick: onConfirm }, "Yes")), className: classnames_1.default(Styles.yesNoConfirmation, !message && Styles.withoutMessage) }, message));
//# sourceMappingURL=yes-no-confirmation.js.map